<template>
  <div class="industry-root py-16">
    <FormattedHeader
      :header="header"
      :subheader="subheader"
      class="max-w-xl mx-auto mb-16 px-4"
    />

    <IndustryGrid class="mb-20" />
  </div>
</template>
<script>
import {
  defineComponent,
  onBeforeMount,
  useMeta,
} from '@nuxtjs/composition-api';
import FormattedHeader from '@/components/FormattedHeader.vue';
import IndustryGrid from '@/modules/InformationPages/Industries/components/IndustryGrid.vue';
import useGlobalSettings from '@/hooks/useGlobalSettings';
export default defineComponent({
  name: 'IndustryRoot',
  components: { FormattedHeader, IndustryGrid },
  layout: 'default',
  setup() {
    const { setHeader } = useGlobalSettings();

    onBeforeMount(() => {
      setHeader({
        header: `Industries We Work With`,
        subheader: '',
        heroImage: null,
        metaTitle: `Industries We Work With | Bambee`,
        registration: false,
        noHero: false,
      });
    });

    const { title, meta } = useMeta();

    title.value = `Industries We Work With | Bambee`;

    meta.value = [
      {
        vmid: 'description',
        hid: 'description',
        name: 'description',
        content: `Bambee works with a wide variety of industries! From food and beverage, to entertainment. We help you get complaint with labor laws and state regulations.`,
      },
      { property: 'fb:app_id', content: '1048426768539865' },
      { property: 'og:type', content: 'website' },
      {
        hid: 'og:title',
        property: 'og:title',
        content: `Industries We Work With | Bambee`,
      },
      {
        hid: 'og:description',
        vmid: 'og:description',
        property: 'og:description',
        content: `Bambee works with a wide variety of industries! From food and beverage, to entertainment. We help you get complaint with labor laws and state regulations.`,
      },
    ];

    return {
      header: `Industries We Work With`,
      subheader: `Bambee works for many different industries for specific reasons such as making businesses compliant with labor laws and other labor federal and state regulations.`,
    };
  },
  head() {},
});
</script>
